import React from 'react';
import styled from 'styled-components';
import { Button, Card, CardIcon, CardValue, IconTypes, Text } from 'components';
import { theme, toRem } from 'design';

interface IPayoutMethodCardProps {
  disabled?: boolean;
  icon?: IconTypes;
  isLoading?: boolean;
  onClick: () => void;
  subTitle?: string;
  title: string;
}

const StyledCard = styled(Card)`
  min-width: ${toRem(318)};
  min-height: ${toRem(270)};
  padding: ${toRem(32)};

  &:hover,
  &:focus-within {
    border-color: ${theme.color.secondary[400]};
  }

  button {
    padding: 0 ${toRem(40)};
    margin-top: ${toRem(8)};
  }
`;

const CardContent = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
`;

const StyledCardIcon = styled(CardIcon)`
  margin-right: 0;
  width: ${toRem(68)};
  height: ${toRem(68)};

  svg {
    width: ${toRem(36)};
    height: ${toRem(36)};
  }
`;

const TitleContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  min-height: ${toRem(105)};

  h3 {
    font-size: ${toRem(20)};
    margin-bottom: ${toRem(5)};
    text-transform: capitalize;
  }

  p {
    color: ${theme.color.neutral[500]};
    font-size: ${toRem(14)};
    text-align: center;
  }
`;

const StyledButton = styled(Button)`
  &:focus {
    background-color: ${theme.color.primary[600]};
    color: ${theme.color.white};
  }
`;

const PayoutMethodCard = ({ disabled, icon, isLoading, title, subTitle, onClick }: IPayoutMethodCardProps) => (
  <StyledCard data-cy="payout-method-card">
    <CardContent>
      {icon && <StyledCardIcon icon={icon} bgColor={theme.color.secondary[25]} fill={theme.color.secondary[400]} />}
      <TitleContainer>
        <CardValue>{title}</CardValue>
        {subTitle && <Text>{subTitle}</Text>}
      </TitleContainer>
      <StyledButton label="Select" size="small" isLoading={isLoading} disabled={disabled || isLoading} data-cy={`${title}-payout-button`} onClick={onClick} />
    </CardContent>
  </StyledCard>
);

export default PayoutMethodCard;
